import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-321b63c0")

_pushScopeId("data-v-321b63c0")
const _hoisted_1 = { class: "time__wrap" }
const _hoisted_2 = { class: "new_work__day flex justify-center" }
const _hoisted_3 = { class: "new_time__day pt-2" }
const _hoisted_4 = { class: "flex w-100 justify-center pt-6" }
const _hoisted_5 = { class: "new-profile-info" }
const _hoisted_6 = { class: "name-user" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider-gray" }, null, -1)
const _hoisted_8 = { class: "area-location" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "button-stamp-group" }
const _hoisted_12 = { class: "group-button" }
const _hoisted_13 = { class: "content-btn flex w-full items-center justify-center" }
const _hoisted_14 = { class: "label ml-4" }
const _hoisted_15 = {
  key: 0,
  class: "time__keeper flex justify-center gap-1"
}
const _hoisted_16 = { class: "check-stamping" }
const _hoisted_17 = { class: "title-stamp" }
const _hoisted_18 = { class: "tool-checkin" }
const _hoisted_19 = { class: "form-date" }
const _hoisted_20 = {
  "slot:header": "",
  class: "header-modal"
}
const _hoisted_21 = { class: "header-title" }
const _hoisted_22 = { class: "body-modal" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "popup-search flex justify-center w-100" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "flex justify-end items-center" }
const _hoisted_27 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ElectricClock = _resolveComponent("ElectricClock")
  const _component_LocationIcon = _resolveComponent("LocationIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_ButtonStamp = _resolveComponent("ButtonStamp")
  const _component_CheckinNext = _resolveComponent("CheckinNext")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputTimeNew = _resolveComponent("InputTimeNew")
  const _component_Department = _resolveComponent("Department")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("section", null, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.workDay), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_ElectricClock, { onChangeTime: _ctx.changeTime }, null, 8, ["onChangeTime"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.profile.employee_name), 1),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_LocationIcon, { class: "cursor-pointer" }),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.textTimeCheckin.unit_name), 1)
            ]),
            _createVNode(_component_Button, {
              class: "w-30",
              onClick: _ctx.showPopupStamp
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('actionEdit')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", {
          class: ["area-group-button", _ctx.timeKeeper && 'active']
        }, [
          _createVNode("div", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buttons, (item, index) => {
              return (_openBlock(), _createBlock(_component_ButtonStamp, {
                "is-show-button": item.isShowButton,
                key: index,
                loading: item.isLoading,
                isNav: true,
                fontSize: item.fontSize,
                isButtonWithIcon: true,
                typeFnBtn: item.type,
                background: item.background,
                onClick: ($event: any) => (_ctx.handleClickCheckTime(item))
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("span", {
                      class: "icon",
                      innerHTML: item.icon && item.icon.src
                    }, null, 8, ["innerHTML"]),
                    _createVNode("span", _hoisted_14, _toDisplayString(item.label), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["is-show-button", "loading", "fontSize", "typeFnBtn", "background", "onClick"]))
            }), 128))
          ]),
          (_ctx.timeKeeper)
            ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(_ctx.timeKeeper.split(':')[0]) + " : " + _toDisplayString(_ctx.timeKeeper.split(':')[1]) + " : " + _toDisplayString(_ctx.timeKeeper.split(':')[2]) + " " + _toDisplayString(_ctx.timeKeeper.split(':')[3]), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_CheckinNext, { class: "cursor-pointer" }),
        _createVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.linkToAllMember && _ctx.linkToAllMember(...args))),
          class: "title"
        }, _toDisplayString(_ctx.t('checkTheStampingRecord')), 1)
      ]),
      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('pleaseEnterTheStampDateAndTime')), 1),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateTool,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateTool = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_InputTimeNew, {
            modelValue: _ctx.timeTool,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.timeTool = $event)),
            class: "relative pl-2",
            style: {"width":"148px","margin-bottom":"6px"}
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      modelValue: _ctx.isShow,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShow = $event)),
      persistent: "",
      classes: "modal-choose-department"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_Department),
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('stampPage.changeOrganization')), 1)
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("p", _hoisted_23, _toDisplayString(_ctx.t('dailyAttendanceHeaders.organization')), 1),
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.paramsTimeLocal.unit_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.paramsTimeLocal.unit_id = $event)),
              placeholder: _ctx.t('pleaseEnterTheAttendanceOrganization'),
              "options-select": _ctx.optionUnit,
              "item-value": "unit_id",
              "item-text": "unit_name",
              required: "",
              class: "w-100 mt-2 mb-6"
            }, null, 8, ["modelValue", "placeholder", "options-select"])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_Button, {
                  disabled: _ctx.isDisabled,
                  class: "h-10 w-35",
                  onClick: _ctx.saveIdUnit
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('actionEdit')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})